/**
 * Fallback defaults for notification polling.
 *
 * The polling owner consumes this named value so the interval is not duplicated
 * as a raw number in the component or runtime environment files.
 */
export const NOTIFICATION_POLL_INTERVAL_MS = 60 * 1000;
